import { render, staticRenderFns } from "./SendRequestExtensionDlg.vue?vue&type=template&id=558affc2"
import script from "./SendRequestExtensionDlg.vue?vue&type=script&lang=js"
export * from "./SendRequestExtensionDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports